import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

interface Breadcrumb {
	label: string,
	url: string,
	link: boolean
};


@Component({
	selector: 'breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

	@Input()
	title: string;

	breadcrumbs: Array<Breadcrumb>;

	constructor( private route: ActivatedRoute ) {
	}

	ngOnInit() {
		this.breadcrumbs= this.buildBreadcrumb( this.route.root );
	}

	private buildBreadcrumb( route: ActivatedRoute, url: string = '', breadcrumbs: Array<Breadcrumb> = [] ): Array<Breadcrumb> {
		const bcConfig = route.routeConfig && route.routeConfig.data && route.routeConfig.data['breadcrumb'];

		const label = bcConfig? bcConfig['label']: null;
		const path = route.routeConfig && route.routeConfig.path? route.routeConfig.path: '';

		const nextUrl = `${url}${path}/`;

		let breadcrumb = null;
		let newBreadcrumbs = breadcrumbs;

		if( label ) {
			breadcrumb = {
				label: label,
				url: nextUrl,
				link: bcConfig['link'] == null? true: bcConfig['link']
			};
			newBreadcrumbs = [ ...breadcrumbs, breadcrumb ];
		}
		
		return route.firstChild? this.buildBreadcrumb( route.firstChild, nextUrl, newBreadcrumbs ): newBreadcrumbs;
	}

}
